import { render, staticRenderFns } from "./detailsInfo.vue?vue&type=template&id=6511bf6c&scoped=true&"
import script from "./detailsInfo.vue?vue&type=script&lang=js&"
export * from "./detailsInfo.vue?vue&type=script&lang=js&"
import style0 from "./detailsInfo.vue?vue&type=style&index=0&id=6511bf6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6511bf6c",
  null
  
)

export default component.exports